import { ACTIVITY } from "../constants";

const initialState = {
  activities: [],
  isLoadingGetActivities: false,
  error: null,
};

const activityReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case ACTIVITY.GET_ACTIVITIES:
      return {
        ...state,
        isLoadingGetActivities: true,
      };
    case ACTIVITY.GET_ACTIVITIES_FAILURE:
      return {
        ...state,
        isLoadingGetActivities: false,
        error: action.payload,
      };
    case ACTIVITY.GET_ACTIVITIES_SUCCESS:
      return {
        ...state,
        isLoadingGetActivities: false,
        activities: action.payload.data,
        total: action.payload.total,
        error: null,
      };
    case ACTIVITY.DELETE_ACTIVITY_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default activityReducer;
